import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { boxApply1qmzdb3dh90hg as boxApply } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ extends ViewWrapper() {
      constructor() {
        Companion_instance = null;
        super();
        Companion_instance = this;
      }
      rcu() {
        return null;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ViewWrapperClass;
function ViewWrapper() {
  if (ViewWrapperClass === VOID) {
    class $ {
      constructor($box) {
        Companion_getInstance();
        boxApply(this, $box);
      }
    }
    initMetadataForClass($, 'ViewWrapper');
    ViewWrapperClass = $;
  }
  return ViewWrapperClass;
}
//region block: exports
export {
  ViewWrapper as ViewWrapper1d2k0qoolhu36,
  Companion_getInstance as Companion_getInstance2xbytizsyx2ps,
};
//endregion

//# sourceMappingURL=ViewWrapper.mjs.map
